export default "__VITE_ASSET__8e03c6a9__"